
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruises/news/[id]",
      function () {
        return require("private-next-pages/cruises/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruises/news/[id]"])
      });
    }
  